import { ReceiptText, Briefcase, IdCard, Scale, ShieldCheck, FileText, Calculator, PenTool, Building2 } from "lucide-react";

// Category → icon + accent palette (used as clipart-style badges on service cards)
export const CATEGORY_META = {
  "Tax":        { icon: ReceiptText, accent: "#D17B5D", bg: "rgba(209,123,93,0.12)", bgSolid: "#FBEEE6" },
  "Business":   { icon: Briefcase,   accent: "#1E4D3B", bg: "rgba(30,77,59,0.12)",   bgSolid: "#E4EDE8" },
  "Identity":   { icon: IdCard,      accent: "#1E40AF", bg: "rgba(30,64,175,0.12)",  bgSolid: "#E0E8FA" },
  "Legal":      { icon: Scale,       accent: "#7C3AED", bg: "rgba(124,58,237,0.12)", bgSolid: "#EFE7FB" },
  "Compliance": { icon: ShieldCheck, accent: "#047857", bg: "rgba(4,120,87,0.12)",   bgSolid: "#DAF1E5" },
  "Other":      { icon: FileText,    accent: "#5C6661", bg: "rgba(92,102,97,0.12)",  bgSolid: "#ECEAE4" },
};

// Per-service override map (slug-based fallback when category isn't enough flavour)
const SERVICE_ICON_OVERRIDES = {
  "accounting": Calculator,
  "digital-signature": PenTool,
  "msme-registration": Building2,
  "company-registration": Briefcase,
};

export const getServiceMeta = (service) => {
  const meta = CATEGORY_META[service?.category] || CATEGORY_META.Other;
  const override = SERVICE_ICON_OVERRIDES[service?.id];
  return { ...meta, icon: override || meta.icon };
};

export const CATEGORY_OPTIONS = Object.keys(CATEGORY_META);
